import state from './modulePaymentState.js'
import mutations from './modulePaymentMutation.js'
import actions from './modulePaymentActions.js'
import getters from './modulePaymentGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

